import React from 'react';
import './declaracoesEspecificas.scss';

//Componentes
import CheckObligation from '../../components/checkObligation'
import Dropdown from '../../../../components/dropdown';
import Form from '../../../../components/form';

class DeclaracoesEspecificas extends React.Component {
  constructor(props) {
    super(props)
    this.props.updateState({ currentValidation: this.handleValidations });
    this.setDeclaracoesEspecificas = (changes) => {
      this.props.updateState({
        declaracoesEspecificas: { ...this.props.declaracoesEspecificas, ...changes },
      });
    };
    this.changeDeclaracoesEspecificasForm = this.changeDeclaracoesEspecificasForm.bind(this);
  }

  componentWillMount() {
    this.formFields = []
    const {
      getListRendaMensalAction,
      getListPatrimonioAction,
    } = this.props;
    getListRendaMensalAction();
    getListPatrimonioAction();
  }


  changeDeclaracoesEspecificasForm(name, value) {
    const form = this.props.declaracoesEspecificas.form;
    this.setDeclaracoesEspecificas({ form: { ...form, [name]: value } });
  }

  CheckObligationAssociado = (props) => <CheckObligation {...props} currentStep={this.props.currentStep} />;

  render() {
    const {
      form,
    } = this.props.declaracoesEspecificas;

    const {
      dropdownDadosRendaMensalList,
      loadingListRendaMensal,
      dropdownDadosPatrimonioList,
      loadingListPatrimonio
    } = this.props.rendaPatrimonioReducer;


    const CheckObligationAssociado = this.CheckObligationAssociado;
  
    return (
      <Form name="declaracoesEspecificasForm" noValidate={true}>
        <CheckObligationAssociado field="declaracoesEspecificasObrigatorias_faixaRendaMensal" >
          {(validacoes) =>
            <div className="col-50">
              <Dropdown
                label="Renda Mensal"
                name="declaracoesEspecificasObrigatorias_faixaRendaMensal"
                required={validacoes.obrigatorio}
                value={form.declaracoesEspecificasObrigatorias_faixaRendaMensal}
                onChange={(e) => this.changeDeclaracoesEspecificasForm(e.name, e.value)}
                dataSource={dropdownDadosRendaMensalList}
                loading={loadingListRendaMensal}
                returnObject={this.createRefFields}
              />
            </div>}
        </CheckObligationAssociado>
        <CheckObligationAssociado field="declaracoesEspecificasObrigatorias_faixaPatrimonio" >
          {(validacoes) =>
            <div className="col-50">
              <Dropdown
                label="Patrimônio"
                name="declaracoesEspecificasObrigatorias_faixaPatrimonio"
                required={validacoes.obrigatorio}
                value={form.declaracoesEspecificasObrigatorias_faixaPatrimonio}
                onChange={(e) => this.changeDeclaracoesEspecificasForm(e.name, e.value)}
                dataSource={dropdownDadosPatrimonioList}
                loading={loadingListPatrimonio}
                returnObject={this.createRefFields} />
            </div>}
        </CheckObligationAssociado>
      </Form>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }
  
  handleValidations = async () => {
    const keys = Object.keys(this.formFields);
    if (keys.length === 0) return true;

    for (const key of keys)
      if (this.formFields[key].input === null)
        delete this.formFields[key];
      else
        if (!await this.formFields[key].validate(this.formFields[key].input)) return false;

    return true;
  };
}

export default DeclaracoesEspecificas;
